import { Lesson } from './lesson';
export class UnsubscribeCautionLesson {
    constructor(data, config) {
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lesson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.title = data.title;
        this.description = data.description;
        this.lesson = new Lesson(data.lesson, config);
    }
}
